module.exports = __webpack_public_path__ + "static/media/house_blue.d4afddde.svg";